import React from "react";

const MoveOuts = () => {
  return (
    <div className="MoveOuts">
      <p>You have no upcoming move outs.</p>
    </div>
  );
};

export default MoveOuts;
